import { FunctionComponent } from 'react';

import { styled } from 'styled-components';
import { paletteHelper, SITE_HEADER_HEIGHT_PX } from '@property.com.au/ui-kit';
import { SearchLandingPageVGDisclaimerFooterWithData } from '../components/SearchLandingPageVGDisclaimerFooter/SearchLandingPageVGDisclaimerFooterWithData';
import { SearchLandingPageSeoFooterWithData } from '../components/SearchLandingPageSeoFooterWithData/SearchLandingPageSeoFooterWithData';
import { SearchLandingPageHeaderWithData } from '../components/SearchLandingPageHeaderWithData/SearchLandingPageHeaderWithData';
import { SearchLandingPageListWithData } from '../components/SearchLandingPageList/SearchLandingPageListWithData';
import { useSearchLandingPageTrackView } from '../hooks/useSearchLandingPageTrackView';
import { User } from '@property.com.au/argonaut';

const SearchLandingPageScreenContainer = styled.main`
  background-color: ${paletteHelper('backgroundSecondaryBase')};
  padding: ${SITE_HEADER_HEIGHT_PX}px 0 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const SearchLandingPageContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  /*  Needed so footer is always at the bottom */
  justify-content: space-between;
`;

const SearchLandingPageScreen: FunctionComponent<{ user: User }> = ({ user }) => {
  useSearchLandingPageTrackView({ user });
  return (
    <SearchLandingPageScreenContainer>
      <SearchLandingPageContentContainer>
        <SearchLandingPageHeaderWithData />
        <SearchLandingPageListWithData />
        <SearchLandingPageVGDisclaimerFooterWithData />
        <SearchLandingPageSeoFooterWithData />
      </SearchLandingPageContentContainer>
    </SearchLandingPageScreenContainer>
  );
};

export default SearchLandingPageScreen;
